import script from "./MenuSubcategory.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuSubcategory.vue?vue&type=script&setup=true&lang=js"

import "./MenuSubcategory.vue?vue&type=style&index=0&id=36bcc908&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36bcc908"]])

export default __exports__